import { Component, Input, ViewChild, OnInit, ElementRef } from "@angular/core";
import { MatTable } from "@angular/material/table";
import { Misc } from "../util/misc";
import { ToastrComponent } from "../util/toastr/toastr.component";
import { UntypedFormControl } from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { forkJoin, Observable, of } from "rxjs";
import { Profissional } from "src/app/models/profissional.model";
import { Equipe } from "src/app/models/equipe.model";
import { Contrato } from "src/app/models/contrato.model";
import { Encargo } from "src/app/models/encargo.model";
import { PriceParamProjeto } from "src/app/models/price-param-projeto.model";
import { ProfissionalService } from "src/app/services/profissional.service";
import { EquipeService } from "src/app/services/equipe.service";
import { CalculoService } from "src/app/services/calculo.service";
import { PriceParamProjetoService } from "src/app/services/price-param-projeto.service";
import { PriceParam } from "src/app/models/price-param.model";
import { ActivatedRoute } from "@angular/router";
import { EstimativaService } from "src/app/services/estimativa.service";
import * as constants from "src/app/models/constants/constants";
import * as XLSX from "xlsx";
import { BonificacaoService } from "src/app/services/bonificacao.service";
import { PriceParamService } from "src/app/services/price-param.service";
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: "app-bodyshop",
  templateUrl: "./bodyshop.component.html",
  styleUrls: ["./bodyshop.component.scss"],
})
export class BodyShopComponent implements OnInit {
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild("tabelaExport") tabelaExport: ElementRef;

  @Input() estimativaId = 108;
  @Input() somenteLeitura: boolean = false;

  filtroPerfil: UntypedFormControl = new UntypedFormControl();

  displayedColumns: string[] = [
    "nome",
    "perfil",
    "baseHoras",
    "custoHoraMedio",
    "precoHora",
    "margemLiquida",
    "receitaBruta",
    "acoes",
  ];

  loading = true;

  equipes: Array<Equipe> = [];
  profissionais: Profissional[] = [];
  profissionaisFiltrada: Observable<Profissional[]> = of([]);

  contratos: Contrato[];
  encargos: Encargo[];
  param: PriceParamProjeto[];
  manutencaoEquipe: Equipe = null;

  idTipoContratoPadrao: number;
  idTipoEncargoPadrao: number;

  mediaPrecoHora = "0";
  mediaMargemLiquida = "0";
  totalReceitaBruta: any;

  isBodyShop: Boolean = false;

  receitaBrutaSugerido: number = 0;
  custoHoraMedioSugerido: number = 0;
  valorHoraMedioVendaSugerido: number = 0;
  quantidadeHorasSugerido: number = 0;

  comissaoSugerido: number = 0;
  liderancaSugerido: number = 0;
  liderancaAdotado: number = 0;

  mediaPercentualLideranca = "0";
  mediaPercentualBonificacao = "0";

  totalReceitaPonderado: number = 0;

  receitaBrutaAdotado: number = 0;
  liderancaPctAdotado: number = 0;

  margemPonderadaPct: number = 0;
  liderancaPonderadaPct: number = 0;
  bonificacaoPonderadaPct: number = 0;

  margemPonderadaGridPct: number = 0;
  liderancaPonderadaGridPct: number = 0;
  bonificacaoPonderadaGridPct: number = 0;

  liderancaGlobalPct: number = 0;

  public isBodyShopTipo = false;
  public usarBonifPorPerfil = false;

  recomendado = {
    lideranca: 0,
    margem: 0
  };

  constructor(
    protected profissionalService: ProfissionalService,
    protected equipeService: EquipeService,
    protected calculoService: CalculoService,
    public misc: Misc,
    protected priceParamProjetoService: PriceParamProjetoService,
    protected toastr: ToastrComponent,
    private estimativaService: EstimativaService,
    private activatedRouter: ActivatedRoute,
    private bonificacaoService: BonificacaoService,
    private priceParamService: PriceParamService
  ) { }

  ngOnInit() {
    this.redirect();
    const defaultParameters: Array<PriceParam> = JSON.parse(
      localStorage.getItem("parametrosSistemaPW"),
    );
    const estimativaId = this.activatedRouter.snapshot.params.id;

    this.estimativaService.verificarParamsProject(estimativaId).subscribe();

    this.idTipoContratoPadrao = defaultParameters.find(
      (p) => p.nome === "IdTipoContratoPadrao",
    )?.valor;
    this.idTipoEncargoPadrao = defaultParameters.find(
      (p) => p.nome === "IdTipoEncargoPadrao",
    )?.valor;

    if (!this.idTipoContratoPadrao || !this.idTipoEncargoPadrao) {
      this.toastr.mostrarMensagem(
        "erro",
        "Erro",
        "Parâmetros padrão do sistema (Tipo de Contrato e/ou Tipo de Encargo) não configurados.",
      );
      return;
    }

    this.estimativaService.getById(estimativaId).subscribe({
      next: (response: any) => {
        this.somenteLeitura =
          response.statusId ===
          constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA;

        this.isBodyShopTipo = Number(response?.estimativaTipoId) === 2;

        const raw =
          (response as any)?.bodyShopBonificacaoPorPerfil ??
          (response as any)?.bodyShopBonifPerfil ??
          (response as any)?.BodyShopBonifPerfil ??
          0;

        this.usarBonifPorPerfil = raw === 1 || raw === true || raw === "1";

        const clienteId = Number(response?.projeto?.clienteId) || 0;
        this.carregarRecomendados(clienteId);
        this.rebuildColumns();
        this.carregarCampos();

      },
      error: () => {
        this.rebuildColumns();
        this.carregarCampos();
      },
    });
  }

  displayFn(profissional: any): string {
    return profissional && profissional.cargo
      ? profissional.cargo.nome
      : profissional && profissional.nome
        ? profissional.nome
        : "";
  }

  private rebuildColumns(): void {
    const base = [
      "nome",
      "perfil",
      "baseHoras",
      "custoHoraMedio",
      "precoHora",
      "margemLiquida",
    ];

    if (this.isBodyShopTipo && this.usarBonifPorPerfil) {
      this.displayedColumns = [
        ...base,
        // "percentualLideranca",
        "percentualBonificacao",
        "receitaBruta",
        "acoes",
      ];
    } else {
      this.displayedColumns = [...base, "receitaBruta", "acoes"];
    }
  }

  redirect() {
    const perfilLogado = JSON.parse(
      localStorage.getItem("currentUserPricingWeb"),
    );
    const perfilTipo = perfilLogado.perfil[0].id;
    if (perfilTipo == constants.PerfilConstants.ID_PERFIL_DELIVERY) {
      this.isBodyShop = true;
    }
  }

  carregarCampos() {
    this.loading = true;

    this.equipeService.getByPropostaId(this.estimativaId).subscribe({
      next: (result) => {
        this.equipes = result.items;

        this.equipes.forEach((equipe) => {
          equipe.receitaBruta = Number(
            (equipe.baseHora * equipe.precoHora).toFixed(2),
          );
        });

        this.calcularTotais();

        this.profissionalService.getAll().subscribe({
          next: (result) => {
            this.profissionais = result.items.filter((x) => x.ativo);

            this.profissionaisFiltrada = this.filtroPerfil.valueChanges.pipe(
              startWith(""),
              map((value) => this._filter(value)),
            );

            this.priceParamProjetoService
              .getByEstimativa(this.estimativaId)
              .subscribe({
                next: (param) => {
                  this.param = param.items;

                  const receitaBrutaAdotado =
                    this.param.find((p) => p.nome === "receitaBrutaAdotado")
                      ?.valor || 0;

                  this.calculoService
                    .calcularPricing(this.estimativaId, receitaBrutaAdotado)
                    .subscribe({
                      next: (res) => {
                        console.log("pricing: ", res);
                        this.atualizarvaloresPrice(res);

                        const paramLideranca = this.getParamPct({ id: 35 }) || this.getParamPct({ nome: 'lideranca' }) || 0;
                        const primeiroPct = Number(this.equipes?.[0]?.percentualLideranca ?? NaN);
                        this.liderancaGlobalPct = Number.isFinite(primeiroPct) ? primeiroPct : Number(paramLideranca);

                        if (this.isBodyShopTipo && this.usarBonifPorPerfil) {
                          this.equipes.forEach(eq => {
                            eq.percentualLideranca = Number(this.liderancaGlobalPct) || 0;
                          });
                        }

                        this.equipes.forEach((equipe) => {
                          equipe.comissao = this.comissaoSugerido;
                          equipe.lideranca = this.liderancaSugerido;

                          if (!equipe.custoHora || equipe.custoHora === 0) {
                            equipe.custoHora = res.custoHoraMedioSugerido;
                          }

                          if (!this.usarBonifPorPerfil) {
                            equipe.precoHora = this.calcularPrecoHora(
                              Number(equipe.baseHora),
                              Number(equipe.custoHora),
                              Number(equipe.margemLiquida),
                              equipe,
                            );
                          } else {
                            if (!equipe.precoHora || equipe.precoHora === 0) {
                              equipe.precoHora =
                                res.valorHoraMedioVendaSugerido;
                            }
                          }

                          equipe.receitaBruta = Number(
                            (equipe.baseHora * equipe.precoHora).toFixed(2),
                          );
                        });

                        this.equipes.forEach((e) =>
                          this.debugEncargos("init", e),
                        );

                        this.calcularTotais();
                      },
                      error: (error) => {
                        this.misc.processError(
                          error,
                          "Erro ao calcular valores atualizados do pricing.",
                        );
                      },
                      complete: () => {
                        this.loading = false;
                      },
                    });
                },
                error: (error) => {
                  this.misc.processError(
                    error,
                    "Não foi possível carregar os parâmetros de margem de contribuição.",
                  );
                  this.loading = false;
                },
              });
          },
          error: (error) => {
            this.misc.processError(
              error,
              "Não foi possível carregar a lista de profissionais.",
            );
            this.loading = false;
          },
        });
      },
      error: (error) => {
        this.misc.processError(
          error,
          "Não foi possível carregar a lista de equipes.",
        );
        this.loading = false;
      },
    });
  }

  atualizarvaloresPrice(dados: any): void {
    if (!dados) return;

    this.receitaBrutaSugerido = dados.receitaBrutaSugerido ?? 0;
    this.custoHoraMedioSugerido = dados.custoHoraMedioSugerido ?? 0;
    this.valorHoraMedioVendaSugerido = dados.valorHoraMedioVendaSugerido ?? 0;
    this.quantidadeHorasSugerido = dados.quantidadeHorasSugerido ?? 0;
    this.comissaoSugerido = dados.comissaoSugerido ?? 0;
    this.liderancaSugerido = dados.liderancaSugerido ?? 0;

    this.receitaBrutaAdotado = Number(dados.receitaBrutaAdotado ?? 0);

    const rbSug = Number(dados?.receitaBrutaSugerido ?? 0);
    const resLiqSug = Number(dados?.resultadoLiquidoSugerido ?? 0);
    const lidSug = Number(dados?.liderancaSugerido ?? 0);
    const comSug = Number(dados?.comissaoSugerido ?? 0);

    if (rbSug > 0) {
      this.margemPonderadaPct = Number(((resLiqSug / rbSug) * 100).toFixed(2));
      this.liderancaPonderadaPct = Number(((lidSug / rbSug) * 100).toFixed(2));
      this.bonificacaoPonderadaPct = Number(
        ((comSug / rbSug) * 100).toFixed(2),
      );
    } else {
      this.margemPonderadaPct = 0;
      this.liderancaPonderadaPct = 0;
      this.bonificacaoPonderadaPct = 0;
    }

    const pctDoPayload = Number(
      dados.liderancaPercentAdotado ??
      dados.liderancaPctAdotado ??
      dados.liderancaPercent ??
      0,
    );
    const valorLiderancaAdotado = Number(dados.liderancaAdotado ?? 0);

    if (pctDoPayload > 0) {
      this.liderancaPctAdotado = pctDoPayload;
    } else if (this.receitaBrutaAdotado > 0 && valorLiderancaAdotado > 0) {
      this.liderancaPctAdotado =
        (valorLiderancaAdotado / this.receitaBrutaAdotado) * 100;
    } else {
      this.liderancaPctAdotado =
        this.getParamPct({ id: 35 }) ||
        this.getParamPct({ nome: "lideranca" }) ||
        0;
    }

    this.totalReceitaPonderado = Number(
      ((this.receitaBrutaAdotado * this.liderancaPctAdotado) / 100).toFixed(2),
    );
  }

  editar(equipe: Equipe) {
    this.manutencaoEquipe = JSON.parse(JSON.stringify(equipe));
    this.filtroPerfil.setValue(this.manutencaoEquipe.profissional.cargo);

    if (
      this.manutencaoEquipe?.profissional &&
      (this.manutencaoEquipe.profissional.custoHoraBaixo == null ||
        this.manutencaoEquipe.profissional.custoHoraAlto == null)
    ) {
      this.profissionalService
        .getByCargoId(this.manutencaoEquipe.profissional.cargo.id)
        .subscribe((p) => {
          const ref = p.items?.[0];
          if (ref) {
            this.manutencaoEquipe.profissional.custoHoraBaixo =
              ref.custoHoraBaixo;
            this.manutencaoEquipe.profissional.custoHoraAlto =
              ref.custoHoraAlto;
          }
          this.aplicarBonificacaoPorMargem(this.manutencaoEquipe, false);
          this.recalcularPrecoHora(this.manutencaoEquipe);
        });
    } else {
      this.aplicarBonificacaoPorMargem(this.manutencaoEquipe, false);
      this.recalcularPrecoHora(this.manutencaoEquipe);
    }
  }

  criarNovo() {

    this.resetFiltroPerfil();

    this.manutencaoEquipe = new Equipe();
    this.manutencaoEquipe.id = 0;
    this.manutencaoEquipe.estimativaId = this.estimativaId;
    this.manutencaoEquipe.nome = "";

    this.manutencaoEquipe.profissional = {
      id: 0,
      baseHora: 0,
      custoHoraBaixo: 0,
      custoHoraAlto: 0,
      custoHoraMedio: 0,
      custoCooperado: 0,
      ativo: true,
      cargo: { id: null, nome: "" } as any,
      contrato: { id: null } as any,
      encargo: { id: null } as any,
    } as any;

    const margemLiquidaAux = this.param.find((p) => p.priceParamId === 25);
    this.manutencaoEquipe.margemLiquida = margemLiquidaAux
      ? margemLiquidaAux.valor
      : 0;
    this.manutencaoEquipe.receitaBruta = 0;
    this.manutencaoEquipe.precoHora = 0;

    this.equipes.unshift(this.manutencaoEquipe);
    this.table.renderRows();
    this.calcularTotais();

    if (this.isBodyShopTipo && this.usarBonifPorPerfil) {
      const pctLidParam = this.getParamPct({ id: 35 }) || this.getParamPct({ nome: "lideranca" }) || 0;
      const pctLid = Number(this.liderancaGlobalPct ?? pctLidParam);
      this.manutencaoEquipe.percentualLideranca = Number(pctLid) || 0;

      const pctBon =
        this.getParamPct({ id: 22 }) ||
        this.getParamPct({ nome: "bonificacao" }) ||
        0;
      this.manutencaoEquipe.percentualBonificacao = Number(pctBon) || 0;

      this.aplicarBonificacaoPorMargem(this.manutencaoEquipe);
    }
  }

  private _filter(value: any): Profissional[] {
    if (!this.profissionais) return [];
    if (typeof value === "string") {
      const filterValue = value.toLowerCase();
      return this.profissionais.filter((option) =>
        option.cargo?.nome?.toLowerCase().includes(filterValue),
      );
    }
    return this.profissionais;
  }

  cancelar() {
    if (this.manutencaoEquipe && this.manutencaoEquipe.id === 0) {
      this.equipes.shift();
    } else {
      this.equipes[
        this.equipes.indexOf(
          this.equipes.find((p) => p.id === this.manutencaoEquipe.id),
        )
      ] = JSON.parse(JSON.stringify(this.manutencaoEquipe));
    }

    this._filter("");
    this.manutencaoEquipe = null;

    this.filtroPerfil.setValue("");

    this.table.renderRows();
    this.resetFiltroPerfil();

    this.calcularTotais();
  }

  excluir(id: number) {
    this.loading = true;

    this.equipeService
      .delete(id)
      .subscribe({
        next: () => {
          this.equipes = this.equipes.filter((p) => p.id != id);

          this.calcularTotais();

          this.toastr.mostrarMensagem(
            "sucesso",
            "Sucesso",
            "Profissional removido com sucesso!",
          );
        },
        error: (error) => {
          this.misc.processError(
            error,
            "Ocorreu um erro ao remover o profissional.",
          );
        },
      })
      .add(() => {
        this.loading = false;
      });
  }

  limpar() {
    if (this.manutencaoEquipe && this.manutencaoEquipe.id === 0) {
      this.manutencaoEquipe.baseHora = null;
      this.manutencaoEquipe.custoHora = null;
      this.manutencaoEquipe.precoHora = null;
      this.manutencaoEquipe.profissional.custoHoraBaixo = null;
      this.manutencaoEquipe.profissional.custoHoraAlto = null;
      this.manutencaoEquipe.profissional.cargo.id = null;
      this.manutencaoEquipe.profissional.contrato.id = null;
      this.manutencaoEquipe.profissional.encargo.id = null;
    }

    this.contratos = null;
    this.encargos = null;
  }

  carregarContrato(equipe: Equipe, profissional?: Profissional) {
    this.limpar();

    if (profissional && profissional.id > 0) {
      equipe.profissional = profissional;
    } else {
      return;
    }

    const cargoId = equipe.profissional.cargo?.id;
    if (cargoId > 0) {
      this.loading = true;

      this.profissionalService.getByCargoId(cargoId).subscribe({
        next: (result) => {
          const profValido =
            (result.items || []).find((p) => p?.ativo) || result.items?.[0];

          if (!profValido) {
            this.toastr.mostrarMensagem("aviso", "Atenção!", "Não há profissional para esse cargo.");
            this.loading = false;
            return;
          }

          equipe.profissional = profValido;

          if (equipe.id !== 0 && (!equipe.nome || `${equipe.nome}`.trim() === "")) {
            equipe.nome = equipe.profissional?.cargo?.nome || "";
          }

          const map = new Map<number, any>();
          this.profissionais.forEach((p) => {
            if (p?.contrato?.id != null) map.set(p.contrato.id, p.contrato);
          });
          this.contratos = Array.from(map.values());

          const contrato = this.contratos.find((p) => p.id === this.idTipoContratoPadrao);
          if (!contrato) {
            this.toastr.mostrarMensagem(
              "aviso",
              "Atenção!",
              "O perfil selecionado não possui o tipo de contrato padrão cadastrado.",
            );
            equipe.profissional = null;
            this.resetFiltroPerfil();
            this.loading = false;
            return;
          }

          equipe.profissional.contrato.id = contrato.id;
          this.carregarEncargo(equipe);
        },
        error: (error) => {
          this.misc.processError(error, "Ocorreu um erro ao carregar lista de contratos.");
          this.loading = false;
        },
      });
    }
  }


  carregarEncargo(equipe: Equipe) {
    this.loading = true;

    equipe.baseHora = null;
    equipe.profissional.custoHoraBaixo = null;
    equipe.custoHora = null;
    equipe.profissional.custoHoraAlto = null;
    equipe.precoHora = null;
    equipe.profissional.encargo = equipe.profissional.encargo || ({} as any);
    equipe.profissional.encargo.id = null;
    this.encargos = null;

    const contratoId = equipe?.profissional?.contrato?.id;
    if (!contratoId || contratoId <= 0) {
      this.loading = false;
      return;
    }

    const mapEnc = new Map<number, any>();
    (this.profissionais || [])
      .filter((p) => p?.contrato?.id === contratoId)
      .forEach((p) => {
        if (p?.encargo?.id != null) mapEnc.set(p.encargo.id, p.encargo);
      });
    this.encargos = Array.from(mapEnc.values());

    const encargoPadrao = this.encargos.find(
      (e) => e.id === this.idTipoEncargoPadrao,
    );
    if (!encargoPadrao) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção!",
        "O perfil selecionado não possui o tipo de encargo padrão cadastrado. Favor solicitar o cadastro ao setor responsável.",
      );
      if (equipe?.profissional) {
        if (equipe.profissional.cargo) equipe.profissional.cargo.id = null;
        if (equipe.profissional.contrato)
          equipe.profissional.contrato.id = null;
      }
      this.loading = false;
      return;
    }

    equipe.profissional.encargo.id = encargoPadrao.id;
    this.carregarDados(equipe);
  }

  carregarDados(equipe: Equipe) {
    this.loading = true;

    equipe.baseHora = null;
    equipe.profissional.custoHoraBaixo = null;
    equipe.custoHora = null;
    equipe.profissional.custoHoraAlto = null;
    equipe.precoHora = null;

    const prof = equipe?.profissional;
    if (!prof || !prof.encargo?.id) {
      this.loading = false;
      return;
    }

    equipe.baseHora = Number(prof.baseHora || 0);

    if (equipe.cooperado) {
      equipe.custoHora = Number(prof.custoCooperado || 0);
    } else {
      equipe.custoHora = Number(prof.custoHoraMedio || 0);
    }

    equipe.precoHora = this.calcularPrecoHora(
      Number(equipe.baseHora),
      Number(equipe.custoHora),
      Number(equipe.margemLiquida),
      equipe,
    );

    this.aplicarBonificacaoPorMargem(equipe);

    this.recalcularPrecoHora(equipe);
    this.calcularTotais();
    this.loading = false;
  }

  recalcularPrecoHora(equipe: Equipe) {
    this.loading = true;

    equipe.precoHora = this.calcularPrecoHora(
      Number(equipe.baseHora),
      Number(equipe.custoHora),
      Number(equipe.margemLiquida),
      equipe,
    );

    equipe.receitaBruta = Number(
      (equipe.baseHora * equipe.precoHora).toFixed(2),
    );

    this.calcularTotais();

    this.loading = false;
  }

  recalcularMargem(equipe: Equipe) {
    this.loading = true;

    const baseHora = Number(equipe.baseHora) || 0;
    const custoHora = Number(equipe.custoHora) || 0;
    const precoHora = Number(equipe.precoHora) || 0;

    const receitaBruta = Number((baseHora * precoHora).toFixed(2));
    equipe.receitaBruta = receitaBruta;

    const totalOutros = (this.param || [])
      .filter((p) => {
        const pid = Number(p.priceParamId);
        const nome = this.norm(p.nome);
        const isMargem = pid === 25 || nome.includes("margem");
        const isLideranca = pid === 35 || nome.includes("lideranca");
        const isBonificacao =
          pid === 22 ||
          nome.includes("bonificacao") ||
          nome.includes("comissao");
        return !(isMargem || isLideranca || isBonificacao);
      })
      .reduce((acc, curr) => acc + Number(curr.valor || 0), 0);

    const percLideranca =
      this.isBodyShopTipo && this.usarBonifPorPerfil
        ? Number(equipe?.percentualLideranca || 0)
        : this.getParamPct({ id: 35 }) ||
        this.getParamPct({ nome: "lideranca" }) ||
        0;

    const percBonificacao =
      this.isBodyShopTipo && this.usarBonifPorPerfil
        ? Number(equipe?.percentualBonificacao || 0)
        : this.getParamPct({ id: 22 }) ||
        this.getParamPct({ nome: "bonificacao" }) ||
        this.getParamPct({ nome: "comissao" }) ||
        0;

    console.log("encargos recalcularMargem", {
      usarBonifPorPerfil: this.usarBonifPorPerfil,
      totalOutros,
      percLideranca,
      percBonificacao,
      encargosPercent: totalOutros + percLideranca + percBonificacao,
    });

    const encargosPercent = totalOutros + percLideranca + percBonificacao;

    const maoObraDireta = baseHora * custoHora;
    const receitaLiquida =
      receitaBruta * (1 - encargosPercent / 100) - maoObraDireta;

    equipe.margemLiquida = Number(
      ((receitaLiquida / receitaBruta) * 100).toFixed(4),
    );

    this.calcularTotais();
    this.loading = false;
  }

  calcularPrecoHora(
    baseHora: number,
    custoHora: number,
    margemLiquida: number,
    equipe?: any,
  ): number {
    const totalOutros = (this.param || [])
      .filter((p) => {
        const pid = Number(p.priceParamId);
        const nome = this.norm(p.nome);
        const isMargem = pid === 25 || nome.includes("margem");
        const isLideranca = pid === 35 || nome.includes("lideranca");
        const isBonificacao =
          pid === 22 ||
          nome.includes("bonificacao") ||
          nome.includes("comissao");
        return !(isMargem || isLideranca || isBonificacao);
      })
      .reduce((acc, curr) => acc + Number(curr.valor || 0), 0);

    let percLideranca = 0;
    let percBonificacao = 0;
    if (this.isBodyShopTipo && this.usarBonifPorPerfil && equipe) {
      percLideranca = Number(equipe?.percentualLideranca || 0);
      percBonificacao = Number(equipe?.percentualBonificacao || 0);
    } else {
      const lidParam =
        this.getParamPct({ id: 35 }) ||
        this.getParamPct({ nome: "lideranca" }) ||
        0;
      const bonParam =
        this.getParamPct({ id: 22 }) ||
        this.getParamPct({ nome: "bonificacao" }) ||
        this.getParamPct({ nome: "comissao" }) ||
        0;
      percLideranca = lidParam;
      percBonificacao = bonParam;
    }

    const totalEncargos =
      totalOutros +
      Number(margemLiquida || 0) +
      percLideranca +
      percBonificacao;

    const preco = (baseHora * custoHora) / (1 - totalEncargos / 100) / baseHora;

    return Number((preco || 0).toFixed(2));
  }

  save(equipe: Equipe) {
    const custoHora = Number(equipe?.custoHora ?? 0);
    const custoMin = Number(equipe?.profissional?.custoHoraBaixo ?? 0);
    if (custoHora < custoMin) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção",
        "Custo Hora Médio não pode ser menor que o Custo Hora Baixo.",
      );
      return;
    }

    const profId = Number(equipe?.profissional?.id ?? 0);
    const cargoId = Number(equipe?.profissional?.cargo?.id ?? 0);
    const encargoId = Number(equipe?.profissional?.encargo?.id ?? 0);
    const contratoId = Number(equipe?.profissional?.contrato?.id ?? 0);
    if (!profId || !cargoId || !encargoId || !contratoId) {
      this.toastr.mostrarMensagem(
        "erro",
        "Dados incompletos",
        "Profissional/Contrato/Encargo inválidos. Selecione o perfil novamente.",
      );
      return;
    }

    const isCreate = Number(equipe?.id ?? 0) === 0;

    const nomeSan = (equipe?.nome ?? "").toString().trim();

    const dtInclusao = (() => {
      if (!isCreate) return undefined;
      const now = new Date();
      const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 19);
      return local;
    })();

    const comissao = Number(
      (equipe as any)?.comissao ?? this.comissaoSugerido ?? 0,
    );
    const lideranca = Number(
      (equipe as any)?.lideranca ?? this.liderancaSugerido ?? 0,
    );

    const usuarioId = (() => {
      try {
        const u = JSON.parse(
          localStorage.getItem("currentUserPricingWeb") || "{}",
        );
        return Number(u?.usuarioId ?? u?.idUsuario ?? u?.id ?? u?.userId ?? 0);
      } catch {
        return 0;
      }
    })();

    this.loading = true;

    const payload: any = {
      id: Number(equipe?.id ?? 0),
      estimativaId: Number(this.estimativaId),
      profissionalId: profId,
      nome: nomeSan,
      clt: Boolean((equipe as any)?.clt ?? false),
      cooperado: Boolean((equipe as any)?.cooperado ?? false),
      baseHora: Number(equipe?.baseHora ?? 0),
      custoHora: Number(equipe?.custoHora ?? 0),
      precoHora: Number(equipe?.precoHora ?? 0),
      margemLiquida: Number(equipe?.margemLiquida ?? 0),
      percentualLideranca: Number(equipe?.percentualLideranca ?? 0),
      percentualBonificacao: Number(equipe?.percentualBonificacao ?? 0),
      ...(dtInclusao ? { dtInclusao } : {}),
      usuarioId: Number(usuarioId ?? 0),
      profissional: null,
      composicaoEquipe: null,
      receitaBruta: Number(equipe?.receitaBruta ?? 0),
      comissao,
      lideranca,
      encargoId: encargoId,
      cargoId: cargoId,
      contratoId: contratoId,
    };

    const req$ = isCreate
      ? this.equipeService.create(payload)
      : this.equipeService.update(payload);

    req$
      .subscribe({
        next: (res: any) => {
          if (isCreate) {
            res.objeto.profissional = equipe.profissional;
            res.objeto.receitaBruta = payload.receitaBruta;
            res.objeto.nome = payload.nome;
            res.objeto.comissao = payload.comissao;
            res.objeto.lideranca = payload.lideranca;
            this.equipes[0] = res.objeto;
          }
          this.resetFiltroPerfil();
          this.manutencaoEquipe = null;
          this.table.renderRows();
          this.calcularTotais();
          this.toastr.mostrarMensagem(
            "sucesso",
            "Sucesso",
            "Profissional salvo com sucesso!",
          );
        },
        error: (err) =>
          this.misc.processError(
            err,
            "Não foi possível salvar o profissional.",
          ),
      })
      .add(() => (this.loading = false));
  }

  calcularTotais() {
    const lista = this.equipes ?? [];

    if (lista.length === 0) {
      this.mediaPrecoHora = "0";
      this.mediaMargemLiquida = "0";
      this.mediaPercentualLideranca = "0";
      this.mediaPercentualBonificacao = "0";
      this.totalReceitaBruta = (0).toFixed(2);

      this.margemPonderadaGridPct = 0;
      this.liderancaPonderadaGridPct = 0;
      this.bonificacaoPonderadaGridPct = 0;
      return;
    }

    const somaPh = lista.reduce((acc, curr) => acc + Number(curr.precoHora || 0), 0);
    this.mediaPrecoHora = (somaPh / lista.length || 0).toFixed(2);

    const somaMl = lista.reduce((acc, curr) => acc + Number(curr.margemLiquida || 0), 0);
    this.mediaMargemLiquida = (somaMl / lista.length || 0).toFixed(2);

    if (this.isBodyShopTipo && this.usarBonifPorPerfil) {
      const somaLid = lista.reduce((acc, curr) => acc + Number(curr.percentualLideranca || 0), 0);
      const somaBon = lista.reduce((acc, curr) => acc + Number(curr.percentualBonificacao || 0), 0);
      this.mediaPercentualLideranca = (somaLid / lista.length || 0).toFixed(2);
      this.mediaPercentualBonificacao = (somaBon / lista.length || 0).toFixed(2);
    } else {
      this.mediaPercentualLideranca = "0";
      this.mediaPercentualBonificacao = "0";
    }

    const totalRB = lista.reduce((acc, curr) => acc + (Number(curr.receitaBruta) || 0), 0);
    this.totalReceitaBruta = totalRB.toFixed(2);

    if (totalRB > 0) {
      const somaMargemPonderada = lista.reduce((acc, curr) => {
        const rb = Number(curr.receitaBruta || 0);
        const ml = Number(curr.margemLiquida || 0);
        return acc + rb * ml;
      }, 0);
      this.margemPonderadaGridPct = Number((somaMargemPonderada / totalRB).toFixed(2));

      if (this.isBodyShopTipo && this.usarBonifPorPerfil) {
        const somaLidPond = lista.reduce((acc, curr) => {
          const rb = Number(curr.receitaBruta || 0);
          const lid = Number(curr.percentualLideranca || 0);
          return acc + rb * lid;
        }, 0);
        this.liderancaPonderadaGridPct = Number((somaLidPond / totalRB).toFixed(2));

        const somaBonPond = lista.reduce((acc, curr) => {
          const rb = Number(curr.receitaBruta || 0);
          const bon = Number(curr.percentualBonificacao || 0);
          return acc + rb * bon;
        }, 0);
        this.bonificacaoPonderadaGridPct = Number((somaBonPond / totalRB).toFixed(2));
      } else {
        this.liderancaPonderadaGridPct = 0;
        this.bonificacaoPonderadaGridPct = 0;
      }
    } else {
      this.margemPonderadaGridPct = 0;
      this.liderancaPonderadaGridPct = 0;
      this.bonificacaoPonderadaGridPct = 0;
    }

    if (this.receitaBrutaAdotado > 0 && this.liderancaPctAdotado >= 0) {
      this.totalReceitaPonderado = Number(
        ((this.receitaBrutaAdotado * this.liderancaPctAdotado) / 100).toFixed(2),
      );
    }
  }

  exportarExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.tabelaExport.nativeElement,
    );

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "SheetJS.xlsx");
  }

  onPercentualLiderancaBlur(e: any) {
    e.percentualLideranca = Number(e.percentualLideranca || 0);
    this.recalcularPrecoHora(e);
  }

  onPercentualBonificacaoBlur(e: any) {
    e.percentualBonificacao = Number(e.percentualBonificacao || 0);
    this.recalcularPrecoHora(e);
  }

  private norm(s: any): string {
    return (s ?? "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  private getParamPct(nomeOuId: { id?: number; nome?: string }): number {
    if (!this.param) return 0;
    if (nomeOuId.id != null) {
      const p = this.param.find(
        (x) => Number(x.priceParamId) === Number(nomeOuId.id),
      );
      return Number(p?.valor ?? 0);
    }
    if (nomeOuId.nome) {
      const alvo = this.norm(nomeOuId.nome);
      const p = this.param.find((x) => this.norm(x?.nome).includes(alvo));
      return Number(p?.valor ?? 0);
    }
    return 0;
  }

  private mapBonificacaoPorMargemLocal(margem: number): number {
    const m = Number(margem || 0);
    if (m >= 34.88 && m <= 999.99) return 4.8;
    if (m >= 27.41 && m <= 34.87) return 3.3;
    if (m >= 13.7 && m <= 27.4) return 1.8;
    return 0.0;
  }

  private aplicarBonificacaoPorMargem(
    equipe: any,
    recalc: boolean = true,
  ): void {
    if (!(this.isBodyShopTipo && this.usarBonifPorPerfil)) return;

    const margem = Number(equipe?.margemLiquida || 0);

    this.bonificacaoService
      .calcularBonificacaoSemAcrescimoBodyShop(this.estimativaId, margem)
      .subscribe({
        next: (resp) => {
          if (resp?.sucesso && resp?.retorno) {
            equipe.percentualBonificacao = Number(
              resp.retorno.percentualBonificacao || 0,
            );
          } else {
            equipe.percentualBonificacao =
              this.mapBonificacaoPorMargemLocal(margem);
          }
          if (recalc) this.recalcularPrecoHora(equipe);
        },
        error: () => {
          equipe.percentualBonificacao =
            this.mapBonificacaoPorMargemLocal(margem);
          if (recalc) this.recalcularPrecoHora(equipe);
        },
      });
  }

  onMargemLiquidaBlur(e: any) {
    e.margemLiquida = Number(e.margemLiquida || 0);
    this.aplicarBonificacaoPorMargem(e, false);
    this.recalcularPrecoHora(e);
  }

  private sanitizePctInput(raw: any): string {
    const s0 = (raw ?? "").toString().replace(",", ".");
    const s1 = s0.replace(/[^0-9.]/g, "");
    const parts = s1.split(".");
    if (parts.length <= 2) return s1;
    return parts[0] + "." + parts.slice(1).join("").replace(/\./g, "");
  }

  maskPctDot(
    evt: any,
    row: any,
    field: "percentualLideranca" | "percentualBonificacao",
  ) {
    const val = this.sanitizePctInput(evt?.target?.value);
    evt.target.value = val;
    row[field] = val;
  }

  finalizePct(
    row: any,
    field: "percentualLideranca" | "percentualBonificacao",
  ) {
    const n = Number((row[field] ?? "").toString().replace(",", "."));
    row[field] = Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
    this.recalcularPrecoHora(row);
  }

  private debugEncargos(context: string, equipe?: any) {
    const totalOutros = (this.param || [])
      .filter((p) => {
        const pid = Number(p.priceParamId);
        const nome = this.norm(p.nome);
        const isMargem = pid === 25 || nome.includes("margem");
        const isLideranca = pid === 35 || nome.includes("lideranca");
        const isBonificacao =
          pid === 22 ||
          nome.includes("bonificacao") ||
          nome.includes("comissao");
        return !(isMargem || isLideranca || isBonificacao);
      })
      .reduce((acc, curr) => acc + Number(curr.valor || 0), 0);

    const percLideranca =
      this.isBodyShopTipo && this.usarBonifPorPerfil && equipe
        ? Number(equipe?.percentualLideranca || 0)
        : this.getParamPct({ id: 35 }) ||
        this.getParamPct({ nome: "lideranca" }) ||
        0;

    const percBonificacao =
      this.isBodyShopTipo && this.usarBonifPorPerfil && equipe
        ? Number(equipe?.percentualBonificacao || 0)
        : this.getParamPct({ id: 22 }) ||
        this.getParamPct({ nome: "bonificacao" }) ||
        this.getParamPct({ nome: "comissao" }) ||
        0;

    const margem = Number(equipe?.margemLiquida || 0);
  }

  onGlobalLiderancaBlur(): void {
    if (this.somenteLeitura) return;
    const n = Number((this.liderancaGlobalPct ?? '').toString().replace(',', '.'));
    this.liderancaGlobalPct = Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
    this.aplicarLiderancaGlobalEAtualizar();
  }

  private aplicarLiderancaGlobalEAtualizar(): void {
    if (!(this.isBodyShopTipo && this.usarBonifPorPerfil)) return;
    if (!this.equipes?.length) return;

    const novoPct = Number(this.liderancaGlobalPct || 0);

    this.equipes.forEach(eq => {
      eq.percentualLideranca = novoPct;
      this.recalcularPrecoHora(eq);
    });

    this.table?.renderRows();
    this.atualizarTodasLinhasComLideranca(novoPct);
  }

  private buildPayloadParaUpdate(equipe: Equipe): any {
    const isCreate = Number(equipe?.id ?? 0) === 0;
    const nomeSan = (equipe?.nome ?? "").toString().trim();

    const usuarioId = (() => {
      try {
        const u = JSON.parse(localStorage.getItem("currentUserPricingWeb") || "{}");
        return Number(u?.usuarioId ?? u?.idUsuario ?? u?.id ?? u?.userId ?? 0);
      } catch {
        return 0;
      }
    })();

    const profId = Number(equipe?.profissional?.id ?? 0);
    const cargoId = Number(equipe?.profissional?.cargo?.id ?? 0);
    const encargoId = Number(equipe?.profissional?.encargo?.id ?? 0);
    const contratoId = Number(equipe?.profissional?.contrato?.id ?? 0);

    const comissao = Number((equipe as any)?.comissao ?? this.comissaoSugerido ?? 0);
    const lideranca = Number((equipe as any)?.lideranca ?? this.liderancaSugerido ?? 0);

    const payload: any = {
      id: Number(equipe?.id ?? 0),
      estimativaId: Number(this.estimativaId),
      profissionalId: profId,
      nome: nomeSan,
      clt: Boolean((equipe as any)?.clt ?? false),
      cooperado: Boolean((equipe as any)?.cooperado ?? false),
      baseHora: Number(equipe?.baseHora ?? 0),
      custoHora: Number(equipe?.custoHora ?? 0),
      precoHora: Number(equipe?.precoHora ?? 0),
      margemLiquida: Number(equipe?.margemLiquida ?? 0),
      percentualLideranca: Number(equipe?.percentualLideranca ?? 0),
      percentualBonificacao: Number(equipe?.percentualBonificacao ?? 0),
      usuarioId: Number(usuarioId ?? 0),
      profissional: null,
      composicaoEquipe: null,
      receitaBruta: Number(equipe?.receitaBruta ?? 0),
      comissao,
      lideranca,
      encargoId: encargoId,
      cargoId: cargoId,
      contratoId: contratoId,
    };

    return payload;
  }

  private atualizarTodasLinhasComLideranca(novoPct: number): void {
    this.loading = true;

    const updates$ = (this.equipes || [])
      .filter(eq => Number(eq?.id ?? 0) > 0)
      .map(eq => {
        eq.percentualLideranca = novoPct;
        const payload = this.buildPayloadParaUpdate(eq);
        return this.equipeService.update(payload);
      });

    if (!updates$?.length) {
      this.loading = false;
      return;
    }

    forkJoin(updates$).subscribe({
      next: () => {
        this.calcularTotais();
        this.toastr.mostrarMensagem("sucesso", "Sucesso", "Liderança aplicada em todas as linhas!");
      },
      error: (err) => {
        this.misc.processError(err, "Falha ao atualizar a liderança em todas as linhas.");
      },
    }).add(() => this.loading = false);
  }

  private resetFiltroPerfil(): void {
    this.filtroPerfil.setValue('', { emitEvent: false });
    this.filtroPerfil.markAsPristine();
    this.filtroPerfil.markAsUntouched();
  }

  private toPctNumber(v: any): number {
    if (v == null) return 0;
    if (typeof v === 'number') return isFinite(v) ? v : 0;
    const s = ('' + v).replace(/\./g, '').replace(',', '.').trim();
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  private carregarRecomendados(clienteId: number): void {
    this.priceParamService.getByClienteId(clienteId).subscribe({
      next: (resCli: any) => {
        const itens = (resCli?.items || []).filter((x: any) => x?.ativo);
        this.aplicarRecomendadosDeLista(itens);
        this.carregarRecomendadosPadraoSeFaltou();
      },
      error: () => this.carregarRecomendadosPadraoSeFaltou(),
    });
  }

  private carregarRecomendadosPadraoSeFaltou(): void {
    if (this.recomendado.lideranca && this.recomendado.margem) return;
    this.priceParamService.getByTipo('BS').subscribe({
      next: (resPadrao: any) => {
        const itens = (resPadrao?.items || []).filter((x: any) => x?.ativo);
        this.aplicarRecomendadosDeLista(itens, /*sobrescreverSeZero*/ true);
      },
    });
  }

  private aplicarRecomendadosDeLista(itens: any[], sobrescreverSeZero = false): void {
    const norm = (s: any) =>
      (s ?? '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const toPct = (v: any) => {
      if (typeof v === 'number') return isFinite(v) ? v : 0;
      const s = ('' + v).replace(/\./g, '').replace(',', '.').trim();
      const n = parseFloat(s);
      return isNaN(n) ? 0 : n;
    };

    itens.forEach((x: any) => {
      const id = Number(x?.priceParamId ?? x?.id);
      const nome = norm(x?.nome);
      const val = toPct(x?.valor);

      if ((id === 35 || nome.includes('lideranca')) && (sobrescreverSeZero || !this.recomendado.lideranca)) {
        this.recomendado.lideranca = val;
      }
      if ((id === 25 || nome.includes('margem')) && (sobrescreverSeZero || !this.recomendado.margem)) {
        this.recomendado.margem = val;
      }
    });
  }

  isLiderancaForaDoRecomendado(): boolean {
    const atual = Number(this.liderancaGlobalPct ?? 0);
    const rec = Number(this.recomendado.lideranca ?? 0);
    if (!Number.isFinite(atual) || !Number.isFinite(rec)) return false;
    return atual !== rec;
  }
  getTooltipLideranca(): string {
    const rec = Number(this.recomendado.lideranca ?? 0);
    return `Liderança recomendada: ${rec.toFixed(2).replace('.', ',')}%`;
  }

  isMargemAbaixoDoRecomendado(): boolean {
    const atual = Number(this.margemPonderadaGridPct ?? 0);
    const rec = Number(this.recomendado.margem ?? 0);
    if (!Number.isFinite(atual) || !Number.isFinite(rec)) return false;
    return atual < rec;
  }
  getTooltipMargem(): string {
    const rec = Number(this.recomendado.margem ?? 0);
    const atual = Number(this.margemPonderadaGridPct ?? 0);
    return `Margem atual (${atual.toFixed(2).replace('.', ',')}%) abaixo do recomendado (${rec.toFixed(2).replace('.', ',')}%).`;
  }


}
